import style from './style.css';
import { useEffect } from 'preact/hooks';
import BenefitsSection from './benefitsSection';
import { Fragment } from 'preact';
import { useDispatch } from 'react-redux';
import { ntbActionType } from '../../../actionTypes';
import { tracker, PageLoadType, UserActionType } from '../../../tracking';

const OverlayNonApproved = (props) => {
  const { handleCloseOverlay, shouldShowRetryOption } = props || {};

  const dispatch = useDispatch();

  const pageKey = 'pv_bic_non_PA_overlay';

  const handleEscape = (e) => {
    if (e.key === 'Escape') {
      handleCloseOverlay();
    }
  };

  const handleRetry = () => {
    handleCloseOverlay();
    tracker.trackUserInteraction(
      UserActionType.CLICK,
      'bic_try_different_mobile',
      pageKey,
    );
    dispatch({
      type: ntbActionType.OPEN_ELIGIBILITY_CHECK_MODAL,
      payload: {},
    });
  };

  useEffect(() => {
    tracker.trackPageView(PageLoadType.DYNAMIC, pageKey);
    document.addEventListener('keydown', handleEscape);

    return () => {
      document.removeEventListener('keydown', handleEscape);
    };
  }, []);

  return (
    <Fragment>
      <div className={style.overlayEmiDetailsContainer}>
        <div className={style.headerText}>Credit unavailable</div>
        <div className={style.overlayBodyContainer}>
          <div className={style.text}>
            Sorry our lending partners are unable to provide EMI plans for you
          </div>
          <div className={style.logoContainer}>
            <img
              src='https://iccdn.in/bic/icons/img-wallet.svg'
              alt='wallet-logo'
            />
          </div>
        </div>
        {shouldShowRetryOption && (
          <div className={style.retryText} onClick={handleRetry}>
            Try with another number
          </div>
        )}
        <BenefitsSection />
      </div>
    </Fragment>
  );
};

export default OverlayNonApproved;



// WEBPACK FOOTER //
// ./componentsBICRevamp/buyWithInstacredLanding/overlayNonApproved/index.js